import Skeleton from '@mui/material/Skeleton';
import { Timeline } from '@/common/components/timeline/Timeline.tsx';
import Stack from '@mui/material/Stack';
import { useTheme } from '@mui/material/styles';

export const EventsTimelineSkeleton = () => {
  const theme = useTheme();

  return (
    <Timeline
      backgroundColor={theme.palette.background.paper}
      leftContentProps={{ width: 230, display: { xs: 'none', md: 'initial' } }}
    >
      <TimelineSkeletonItem />
      <TimelineSkeletonItem />
      <TimelineSkeletonItem />
      <TimelineSkeletonItem isLast />
    </Timeline>
  );
};

const TimelineSkeletonItem = (props: { isLast?: boolean }) => {
  return (
    <Timeline.ItemSkeleton
      isLast={props.isLast}
      leftContent={<Skeleton variant="rectangular" width="100%" height={45} />}
      rightContent={
        <Stack gap={2} pt={2}>
          <Skeleton variant="rectangular" height={26} width={230} />
          <Skeleton variant="rounded" height={100} width="100%" />
        </Stack>
      }
    />
  );
};
